import React from "react";
import { NavLink } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import { rootState } from "../../../redux/store";
import { ROUTES } from "../../../constants/constants";

interface INavButtonProps {
    subLink: string,
    label: string
}    

export const NavButton: React.FC<INavButtonProps> = ({subLink, label})=>{
    const { project } = useAppSelector((state: rootState) => state.project);
    
    return (
        <li className="navbar__item">
            {/* <NavLink to={`/configuration/${subLink}?projectId=${project?._id}`} className={({ isActive }) => (isActive ? 'navbar__link navbar__link--active' : 'navbar__link')} end> */}
            <NavLink to={`/${ROUTES.CONFIGURATION}/${project?._id}/${subLink}`} className={({ isActive }) => (isActive ? 'navbar__link navbar__link--active' : 'navbar__link')}>
                {label}
            </NavLink>
        </li>
    )
}